export default __webpack_public_path__ + "static/media/ic_medium.d7223e62.svg";